import "./Services.css";

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Title } from "../Title/Title";

interface Service {
  title: string,
  description: string,
  services: string[],
  uses: string
}

export function Services() {
  const { i18n } = useTranslation();

  const services: Service[] = i18n.t("services", { returnObjects: true });
  return <div className="About main-content">
    <div className='content'>
      {services.map(service => {
        return <div className='slide-text spacing-bottom'>
          <Title text={service.title} />
          <div>
            {service.description}
            <ul>
              { service.services.map(s => <li>{s}</li>) }
            </ul>
            {service.uses}
          </div>
        </div>
      })}
    </div>
  </div>;
}